import React from "react";
import SpotifyEmbed from "./SpotifyEmbed";
import MP3Embed from "./MP3Embed";

export default function MediaAudioItem({ item }) {
  // console.log(item);
  if (item.type.includes("spotify")) {
    return <SpotifyEmbed item={item} />;
  } else if (item.type.includes("mpeg")) {
    return <MP3Embed item={item} />;
  } else {
    return "";
  }
}
